import { i18n, sprintf } from '@/common/utils/i18n'
import { DEFAULT_CONTRACT_VERSOIN } from '@/config/sign/enums'

export const INIT_DATA = {
  // 基础信息
  // 1. 主体信息
  partyInfo: {
    contractorId: null
  },
  // 资质信息
  // 1. 登记簿
  register: {
    id: ''
    // licensePics: null
  },
  business: {
    // licensePics: null,
    // files: null
  },
  isIllegalInfo: {
    isIllegal: 0
  },
  officialUrlInfo: {
    officialUrl: ''
  },
  companyInfo: {},
  proxyInfo: {}, // 委托书照片
  legalInfo: {
    legalName: ''
  },
  contractInfo: {
    contractType: 1,
    contractNo: '',
    partyaName: '',
    partyaAddr: '',
    partyaContact: '',
    contractVersion: DEFAULT_CONTRACT_VERSOIN
  },
  // 2. esc
  escInfo: {
    num: null,
    addr: null,
    checkDate: null,
    licensePics: [null],
    files: null
  },
  // 3. 市政
  cityInfo: {},
  // 4. 土地
  landInfo: {
    resName: null,
    resAddr: null,
    licenseNum: null,
    use: null,
    validateDate: null,
    licensePics: null,
    files: null
  },
  // 5. 卫生
  healthInfo: {
    resName: null,
    resAddr: null,
    licenseNum: null,
    scope: null,
    validateDate: null,
    licensePics: null,
    files: null
  },

  // 6. 销售许可
  sell: {
    resName: null,
    resAddr: null,
    licenseNum: null,
    // openDate: [
    //   {
    //     label: ['1', '2', '3', '4', '5', '6', '7'],
    //     all: true,
    //     isIndeterminate: false,
    //     tips: false,
    //     timeRages: [{ startTime: 1544851019000, endTime: 1544854622000 }]
    //   }
    // ],
    licensePics: null,
    files: null
  },
  // 合同
  accountInfo: {},
  // 启动费
  startupMoney: {
    startupCost: null, // 启动费默认值
    startupExecWeek: sprintf(i18n.gettext('签约%d周后'), 1), // 启动费开始扣费时间
    startupCostProportion: '10%', // 启动费扣费比例
    startupCostLimit: 500 // 单次最大扣费金额
  },
  // 设备信息
  equipmentInfo: {
    deviceFlagbinNeedPad: null
  },
  legal: {
    legalName: null,
    legalType: 0,
    legalId: null, // curp号
    legalPics: [null],
    legalExtra: [null]
  },
  contract: {
    contractType: 1,
    contractVersion: DEFAULT_CONTRACT_VERSOIN,
    contractNo: null,
    // 乙方
    partyaName: null,
    partyaRegisteAddr: null,
    partyaAddr: null,
    partyaEmail: null,
    partyaContact: null,
    partyaTitleType: 1,
    partyaTitleText: null, // partyaTitleType === 4
    partyaPhone: null,
    // 平台配送
    platformType: 1,
    platformRate: null,
    deliveryMinRate: null,
    oneselfType: 1, // 1 支持 2 不支持
    oneselfRate: null, // oneselfType === 1
    contractorType: 1, // 1 股份公司 2 有限责任公司 3 个人; 6  简单公司 和 7 传统公司
    didiAgreement: 1 // 滴滴独家协议 1 是 2 否
  },
  taxInfo: {
    taxId: null,
    taxPics: [],
    taxPayerIdcard: null,
    taxIdcif: null,
    taxPics: [],
    taxId: null,
    taxPayer: null,
    taxPayerAddr: null,
    taxPayerPostcode: null,
    taxSourceType: null,
    taxPaymentMethod: '',
    localTaxPayer: '',
    localTaxId: '',
    localTaxPayerAddr: '',
    localTaxPaymentMethod: '',
    localTaxPics: ''
  },
  authorizationInfo: {
    sign: {},
    payment: {},
    brand: {}
  },
  // 其他
  menuInfo: {},
  othersInfo: {},
  bankInfo: {},
  emailInfo: {}

  // shopOthersInfo: {},
  // shopBankInfo: {},
  // contractorOthersInfo: {},
  // contractorBankInfo: {}
}

export default {
  relatedParty: {}, //根据shopID获取到的主体信息
  signType: -1, // 签约方式
  signForm: { ...INIT_DATA }, // 签约信息
  snapshots: {},
  auditInfo: {},
  auditStatus: {},
  propgress: {},
  packNumList: [],
  shopCommonConfig: {},
  configs: {},
  checkStatus: {},//“已添加”与“未添加”状态
  completeStatus: {} // 是否必填项填写完整
}
